import { useTranslation } from 'react-i18next';

import Sentry from 'src/services/sentry';

import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import OrderTask from 'src/components/ReportViewer/OrderTasks/OrderTask';

import { OrderTaskId } from 'src/models/GalenData/Order.model';
import { I18NextNS } from 'src/models/Language.model';

const OrderTaskList = () => {
  const { t } = useTranslation(I18NextNS.COMMON);
  const { session } = useRemoteBoundStore();

  const {
    order: orderData,
    firstName: patientFirstName,
    lastName: patientLastName,
    dob: patientDOB,
    id: patientPID,
    orderId,
  } = session;

  if (orderId === undefined) {
    Sentry.captureException(new Error(t('message.error.orderNotFound')));
  }

  const tasks: Array<{ id: OrderTaskId; label: string; isComplete: boolean }> =
    [
      {
        id: 'IsSharedWithProvider',
        label: t('orderTasks.resultsShared'),
        isComplete: orderData?.IsSharedWithProvider?.value ?? false,
      },
      {
        id: 'IsSavedToChart',
        label: t('orderTasks.resultsSaved'),
        isComplete: orderData?.IsSavedToChart?.value ?? false,
      },
    ];

  return (
    <div className="w-50 p-3">
      <h5 className="mb-2 fw-bold">{t('orderTasks.title')}</h5>

      <div className="mb-3">
        <p className="mb-0 fs-6">
          {patientFirstName}, {patientLastName}
          {` | ${t('patientFields.DOB')}: ${patientDOB}`}
          {` | ${t('patientFields.PID')}: ${patientPID}`}
        </p>
      </div>

      <div>
        <p className="text-primary mb-0 fw-bold fs-6">
          {t('orderTasks.orderinstructions')}
        </p>
      </div>
      <hr />
      <div>
        {tasks.map((task) => (
          <div key={task.id}>
            <OrderTask
              label={task.label}
              isComplete={task.isComplete}
              taskId={task.id}
            />
            <br />
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrderTaskList;
